import script from "./MonPanierCard.vue?vue&type=script&setup=true&lang=js"
export * from "./MonPanierCard.vue?vue&type=script&setup=true&lang=js"

import "./MonPanierCard.vue?vue&type=style&index=0&id=173e8631&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-173e8631"]])

export default __exports__